package com.example.mystybag.sharedmodels.mystyBag.requestModels

import com.example.mystybag.sharedmodels.AllCommands.UPDATE_USER_PROFILE
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class UpdateUserProfileRequestModel(
    val userId: Long = 0,
    val firstName: String = "",
    val lastName: String = "",
    val email: String = "",
    val dialCode: String = "",
    val phoneNumber: String = "",
    val cityId: Long = 0L,
    val verificationCode: String = ""
) : BaseRequestModel(api = UPDATE_USER_PROFILE)
